import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

let app
let db
let auth
let functions

export function initFirebase() {
  if (!app) {
    app = initializeApp(firebaseConfig)
    const dbName = process.env.VUE_APP_FIREBASE_DB_NAME || 'default'
    db = getFirestore(app, dbName)
    auth = getAuth(app)
    functions = getFunctions(app)
  }
  return { app, db, auth, functions }
}


const { db: firestore, auth: firebaseAuth, functions: firebaseFunctions } = initFirebase()

export { firestore as db, firebaseAuth as auth, firebaseFunctions as functions }
